import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaSave } from 'react-icons/fa';
import { salvarPendenciasContrato } from '~/Services/Juridico/ControleContratoService';
import { extrairMensagemErro } from './useControleContrato';

const CardPendencias = ({ contrato, detalhe, onSalvo }) => {
  const [cessao, setCessao] = useState(false);
  const [aditamento, setAditamento] = useState(false);
  const [rescisao, setRescisao] = useState(false);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (detalhe && detalhe.pendencias) {
      setCessao(detalhe.pendencias.cessao || false);
      setAditamento(detalhe.pendencias.aditamento || false);
      setRescisao(detalhe.pendencias.rescisao || false);
    }
  }, [detalhe]);

  if (!contrato || !detalhe) return null;

  const handleSalvar = async () => {
    setSalvando(true);
    try {
      await salvarPendenciasContrato({
        codigoGrupoEmpresa: contrato.codigo_grupo_empresa,
        codigoConta: contrato.conta,
        codigoBoleto: contrato.boleto,
        cessao,
        aditamento,
        rescisao,
      });
      toast.success('Pendências salvas com sucesso.');
      if (onSalvo) onSalvo();
    } catch (err) {
      toast.error(extrairMensagemErro(err));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header>
        <strong>Pendências do Contrato</strong>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col xs={12} sm={4}>
            <Form.Check
              type="checkbox"
              id="check-cessao"
              label="Cessão"
              checked={cessao}
              onChange={(e) => setCessao(e.target.checked)}
            />
          </Col>
          <Col xs={12} sm={4}>
            <Form.Check
              type="checkbox"
              id="check-aditamento"
              label="Aditamento"
              checked={aditamento}
              onChange={(e) => setAditamento(e.target.checked)}
            />
          </Col>
          <Col xs={12} sm={4}>
            <Form.Check
              type="checkbox"
              id="check-rescisao"
              label="Rescisão"
              checked={rescisao}
              onChange={(e) => setRescisao(e.target.checked)}
            />
          </Col>
        </Row>
        <div className="mt-3 text-right">
          <Button size="sm" variant="primary" onClick={handleSalvar} disabled={salvando}>
            <FaSave className="mr-1" />
            {salvando ? 'Salvando...' : 'Salvar Pendências'}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CardPendencias;
